export default "__VITE_ASSET__CV4MIWZl__"